/* src/app/modules/ct-status/components/cts-gantry-startup-actions/cts-gantry-startup-actions.component.scss */
:host {
  display: grid;
  grid-template-columns: minmax(16.0625rem, 1fr) 6rem;
  align-items: center;
}
sh-text {
  width: max-content;
}
section {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 1rem;
}
.gap-8 {
  gap: 0.5rem;
}
/*# sourceMappingURL=cts-gantry-startup-actions.component.css.map */
